export default __webpack_public_path__ + "static/media/copyLogo.8ac57cc5.svg";